var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-bar'),_c('left-navigation-menu'),_c('page-container'),_c('app-notification'),(_vm.loading)?_c('app-loading-overlay'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }